<template>
    <div>
        <div class="alert-warning">
            <span v-for="failureMessage in failureMessages" :key="failureMessage.key">
                {{failureMessage.value}}
            </span>
        </div>
        <RegisterPanel :sourceModel="sourcevalues" @postForm="postForm"></RegisterPanel>
        <LicenseModal></LicenseModal>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import RegisterPanel from '@/components/register/RegisterPanel.vue'
    import LicenseModal from '@/components/terms/LicenseModal.vue'

    export default {
        name: 'Register',
        components: {
            RegisterPanel,
            LicenseModal
        },
        data() {
            return {
                failureMessages: [""],
                sourcevalues: {
                    populated: false,
                    industries: [],
                    countries: [],
                    initialcountry: "",
                    cadTools: [],
                    tocconsent: null
                }
            }
        },
        computed: {
            ...mapState({
                instance: state => state.instance,
                backLink: state => state.navigation.backLink
            }),
        },
        methods: {
            getModel: async function () {
                var registerContent = await accountApiClient.GetRegisterModel().catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Register Content Connection Failed');
                });
                this.sourcevalues = {
                    industries: registerContent.data.industries,
                    countries: registerContent.data.countries,
                    initialcountry: registerContent.data.countryId,
                    cadTools: registerContent.data.cadTools,
                    tocconsent: registerContent.data.tocConsent,
                    populated: true
                }
            },
            postForm: async function (evt, registerModel) {
                var value = await accountApiClient.PostRegistration(registerModel).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Register Content Connection Failed');
                });
                if (value.status == 200) {
                    if (value.data.success) {
                        this.$store.dispatch('gtmSubmitRegistration');
                        this.$router.push({ name: "RegisterConfirmation" });
                    } else {
                        this.failureMessages = value.data.errors;
                    }
                } else {
                    this.failureMessages = ["Server Interruption"]
                }
            }
        },
        beforeMount: async function() {
            await this.$router.isReady();
            this.getModel();
        }
    }
</script>

<style scoped>
</style>